<template>
    <el-dialog
        title="Edit"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
    >
        <el-form
            label-position="left"
            label-width="120px"
            ref="form"
            :model="form"
        >
            <el-form-item label="是否禁用渠道:" prop="status">
                <el-switch v-model="form.status"></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="loading" @click="onSubmit"
                    >Submit</el-button
                >
                <el-button @click="handleClose">Cancel</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from "../../../server/index";
export default {
    props: ["dialogVisible", "initValue"],
    data() {
        return {
            form: {
                status: "",
            },
            loading: false,
        };
    },
    created() {
        if (this.initValue) {
            console.log("initValue--->", this.initValue);
            this.form.status = this.initValue.status;
        }
    },
    methods: {
        onSubmit() {
            console.log("form--->", this.form);
            this.loading = true;
            const params = {
                id: this.initValue._id,
                status: this.form.status,
            };
            serverApi
                .channelStatus(params)
                .then((res) => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: "Edit success",
                            type: "success",
                        });
                        this.$emit("closeModal", true);
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: "error",
                        });
                    }
                })
                .catch((e) => {
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: "error",
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleClose() {
            this.$emit("closeModal", false);
        },
    },
};
</script>

<style>
</style>